import React from 'react'

// The assessment results on the page (IMP-085), alongside the emailed PDF: the five trait scores as bars,
// then the three report sections the PDF contains. scores: [E, A, C, N, O], 0–24 (lower N = steadier).
const MAX = 24;
const TRAITS = [
    { label: "Extraversion", meaning: "Energy from people and action", value: scores => scores[0] },
    { label: "Agreeableness", meaning: "Cooperation and trust", value: scores => scores[1] },
    { label: "Conscientiousness", meaning: "Organisation and follow-through", value: scores => scores[2] },
    // Shown the friendly way round: high = calm under pressure
    { label: "Emotional stability", meaning: "Calm under pressure", value: scores => MAX - scores[3] },
    { label: "Openness", meaning: "Curiosity and new ideas", value: scores => scores[4] },
];
const SECTIONS = ["Your Profile", "The Entrepreneur in You", "Your Perfect Co-Founder"];

const level = value => (value <= 8 ? "Low" : value <= 16 ? "Moderate" : "High");

export default function ResultsView(props) {
    const { scores, descriptions } = props.results;
    return (
        <section className="Results" aria-labelledby="Results-title">
            <h2 className="Results--title" id="Results-title">Your results</h2>
            <ul className="Results--traits">
                {TRAITS.map(trait => {
                    const value = Math.min(MAX, Math.max(0, trait.value(scores)));
                    return (
                        <li key={trait.label} className="Results--trait">
                            <div className="Results--trait-text">
                                <span className="Results--trait-label">{trait.label}</span>
                                <span className="Results--trait-level">{level(value)}</span>
                            </div>
                            <div className="Results--bar" role="meter" aria-label={trait.label}
                                aria-valuemin={0} aria-valuemax={MAX} aria-valuenow={value} aria-valuetext={`${level(value)}, ${value} of ${MAX}`}>
                                <div className="Results--bar-fill" style={{ width: `${(value / MAX) * 100}%` }}></div>
                            </div>
                            <span className="Results--trait-meaning">{trait.meaning}</span>
                        </li>
                    );
                })}
            </ul>
            {(descriptions || []).slice(0, 3).map((text, index) => (
                <div key={SECTIONS[index]} className="Results--section">
                    <h3 className="Results--section-title">{SECTIONS[index]}</h3>
                    <p className="Results--section-text">{text}</p>
                </div>
            ))}
        </section>
    )
}
